// Oportunidades 2027 · pós-ação DD-30 (docs/oportunidades-2027/02-design/ui-posacao.md; contrato EP-09 "Para o pós-ação").
// As ações A-08/A-09 seguem nos modais ANTIGOS (data-modal → createModal); dentro da tela nova o formulário cuja data-action é IGUAL à `antiga`
// de $urls.acoes (barra) / $urls.acaoNovaOportunidade (#op-fila) passa a postar na `nova` (EP-09) e sai do submit global:
// - a classe .form-ajax sai do form (o $(document).on('submit', '.form-ajax', submitAjax) não casa mais) e o submit é tomado na CAPTURA da
//   window, antes de qualquer ouvinte do document (R-46: nenhum POST fora da trava);
// - a resposta NÃO passa pelo switchReturns (method "redirect" navegaria): lida aqui, pela tabela "Leitura da resposta";
// - trava no MÓDULO (DD-30 item 8): Set `emVoo` com a chave acao:id (6 do detalhe) ou newOpportunitySave:tipo. Chave presente = 0 POST e o
//   alerta "em voo" no modal (inclusive no modal reaberto depois do Esc). A chave só sai quando o fetch ASSENTA (qualquer desfecho); o
//   relógio de 30 s mostra o E-PA7 e NÃO solta a trava (soltar duplicaria: o servidor não corta escrita);
// - `message` vem escapada (e()): decodificada UMA vez por textarea (RCDATA: entidade vira caractere, tag fica texto) e posta por textContent.
// Textos: #op-fila[data-textos-pa] (19 chaves opp27_pa_*/opp27_fora_filtro). Nada de texto de tela neste arquivo.

const ACOES = {
    crmDelete: { cria: false, t: 'opp27_pa_descartada_t', l2: 'opp27_pa_fica_aberta' },
    approveDiscard: { cria: false, t: 'opp27_pa_aprovado_t', l2: 'opp27_pa_fica_aberta' },
    askDiscard: { cria: false, t: 'opp27_pa_pedido_t', l2: 'opp27_pa_segue_ativa' },
    denyDiscard: { cria: false, t: 'opp27_pa_negado_t', l2: 'opp27_pa_negado_txt' },
    changePriceSave: { cria: false, t: 'opp27_pa_valor_t', l2: null },
    duplicateModalSave: { cria: true, t: 'opp27_pa_duplicada_t', l2: 'opp27_pa_duplicada_txt' },
    newOpportunitySave: { cria: true, t: 'opp27_pa_nova_t', l2: null },
};
const RECUSA = ['recusada', 'sem_permissao', 'entrada_invalida'];   // E-PA6; todo o resto de ok:false é E-PA7 (contrato, resposta 2)
const RELOGIO_MS = 30000;
const TOAST_MS = 6000;
const PILHA_MAX = 3;
const GATILHO = { 'F-69': 'crmDelete', 'F-68': 'duplicateModalSave', 'F-05': 'newOpportunitySave' };   // os 3 alcançáveis da tela nova
const ID_MODELO = '999999999';   // #op-fila[data-url-detalhe-modelo] = route('v3.crm.opp27.detalhe', 999999999)

const PosAcao = function () {
    let api = null, tela, fila, lista, det;
    let T = {};
    const emVoo = new Set();
    const infoDe = new WeakMap();      // form → { acao, chave, id, nova }
    const formsDe = new Map();         // chave → Set(form) (modais abertos daquela ação, para soltar o primário quando o voo assenta)
    let notyf = null;
    const abertos = [];
    let foraId = null;

    const t = (k, p) => String(T[k] || '').replace(/:([a-z]+)/g, (m, c) => (p && c in p ? String(p[c]) : m));
    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const json = (s) => { try { return JSON.parse(s || ''); } catch (e) { return null; } };
    const abertaId = () => { const b = det.querySelector(':scope > header.op-barra[data-ticket]'); const n = b ? parseInt(b.dataset.ticket, 10) : NaN; return Number.isInteger(n) ? n : null; };
    const tipoDe = (url) => { const m = /\/acao\/[A-Za-z]+\/([1-3])(?:[/?#]|$)/.exec(String(url || '')); return m ? +m[1] : null; };
    const tipoPagina = () => { const n = json(fila.dataset.acaoNova); return n ? tipoDe(n.nova) : null; };
    const chaveDe = (acao, id, nova) => acao + ':' + (acao === 'newOpportunitySave' ? tipoDe(nova) : id);
    const modelo = (id) => String(fila.dataset.urlDetalheModelo || '').replace('/' + ID_MODELO, '/' + id);
    const comSel = (href, id) => { const u = new URL(href, location.href); u.searchParams.set('sel', String(id)); return u.toString(); };   // LG-73: só o sel muda
    // URL do pedido: a `nova` vem do servidor; só a da MESMA origem é aceita (a resposta e o destino também)
    const mesmaOrigem = (u) => { try { return new URL(u, location.href).origin === location.origin; } catch (e) { return false; } };

    // ---------- mapa antiga → nova ----------
    const mapaAtual = () => {
        const out = [];
        const barra = det.querySelector(':scope > header.op-barra[data-acoes]');
        const id = abertaId();
        const m = barra ? json(barra.dataset.acoes) : null;
        if (m && typeof m === 'object' && id !== null) {
            Object.keys(m).forEach((acao) => { const p = m[acao]; if (ACOES[acao] && acao !== 'newOpportunitySave' && p && typeof p.antiga === 'string' && typeof p.nova === 'string') out.push({ acao: acao, antiga: p.antiga, nova: p.nova, id: id }); });
        }
        const n = json(fila.dataset.acaoNova);
        if (n && typeof n.antiga === 'string' && typeof n.nova === 'string') out.push({ acao: 'newOpportunitySave', antiga: n.antiga, nova: n.nova, id: null });
        return out;
    };
    const preparar = (form) => {
        if (!(form instanceof HTMLFormElement) || infoDe.has(form)) return infoDe.get(form) || null;
        const act = form.getAttribute('data-action');
        if (!act || !form.closest('.modal')) return null;
        const m = mapaAtual().find((x) => x.antiga === act);
        if (!m || !mesmaOrigem(m.nova)) return null;
        const info = { acao: m.acao, id: m.id, nova: m.nova, chave: chaveDe(m.acao, m.id, m.nova) };
        form.setAttribute('data-action', m.nova);
        if (window.jQuery) window.jQuery(form).data('action', m.nova);   // contrato: o submitAjax lê o cache do jQuery
        form.classList.remove('form-ajax');                               // R-46: fora do submit global
        form.dataset.opPa = m.acao;
        infoDe.set(form, info);
        if (!formsDe.has(info.chave)) formsDe.set(info.chave, new Set());
        formsDe.get(info.chave).add(form);
        if (emVoo.has(info.chave)) emVooNoModal(form);
        return info;
    };
    const observar = (muts) => {
        muts.forEach((mu) => mu.addedNodes.forEach((n) => {
            if (!(n instanceof Element) || !n.closest('.modal')) return;
            if (n.matches('form[data-action]')) preparar(n);
            n.querySelectorAll('form[data-action]').forEach(preparar);
        }));
    };

    // ---------- modal ----------
    const primario = (form) => form.querySelector('button[type="submit"], input[type="submit"]');
    const alertar = (form, texto) => {
        form.querySelectorAll('[data-op-pa-alerta]').forEach((n) => n.remove());
        const a = document.createElement('div');
        a.className = 'alert alert-custom alert-light-danger';
        a.setAttribute('role', 'alert');
        a.setAttribute('data-op-pa-alerta', '');
        const tx = document.createElement('div');
        tx.className = 'alert-text';
        tx.textContent = texto;   // portão #12: nunca innerHTML
        a.appendChild(tx);
        const corpo = form.querySelector('.modal-body') || form;
        corpo.insertBefore(a, corpo.firstChild);
    };
    const emVooNoModal = (form) => { alertar(form, t('opp27_pa_em_voo')); const p = primario(form); if (p) p.disabled = true; };
    // C-16c: decodifica a `message` escapada UMA vez sem criar elemento (textarea = RCDATA)
    const decodificar = (s) => { const ta = document.createElement('textarea'); ta.innerHTML = String(s == null ? '' : s); return ta.value; };
    const fecharModal = (form) => {
        const m = form ? form.closest('.modal') : null;
        if (m && window.jQuery && window.jQuery.fn.modal) window.jQuery(m).modal('hide');
    };
    const marcarGatilhos = () => {
        const id = abertaId(), tp = tipoPagina();
        tela.querySelectorAll('[data-f]').forEach((g) => {
            const acao = GATILHO[g.dataset.f];
            if (!acao) return;
            const k = acao + ':' + (acao === 'newOpportunitySave' ? tp : id);
            if (emVoo.has(k)) g.setAttribute('aria-disabled', 'true'); else g.removeAttribute('aria-disabled');
        });
    };

    // ---------- toast (instância própria, DD-30 item 6) ----------
    const instancia = () => {
        if (notyf) return notyf;
        if (typeof window.Notyf !== 'function') return null;
        notyf = new window.Notyf({
            duration: TOAST_MS, ripple: false, dismissible: true,
            position: document.getElementById('lia-event') ? { x: 'center', y: 'bottom' } : { x: 'right', y: 'bottom' },   // [MEDIR] 9: sem #lia-event na tela nova
            types: [
                { type: 'op-ok', className: 'tk-toast op-toast', icon: { className: 'ai ai-check-circle tk-toast-ico', tagName: 'i' } },
                { type: 'op-aviso', className: 'tk-toast op-toast', icon: { className: 'ai ai-exclamation-triangle tk-toast-ico', tagName: 'i' } },
            ],
        });
        return notyf;
    };
    const toast = (tipo, linhas) => {
        const ls = linhas.filter((l) => l);
        const n = instancia();
        if (!n) { const st = document.getElementById('op-status'); if (st) st.textContent = ls.join(' '); return; }
        for (let i = abertos.length - 1; i >= 0; i--) { if (!abertos[i].node || !abertos[i].node.isConnected) abertos.splice(i, 1); }
        while (abertos.length >= PILHA_MAX) { const v = abertos.shift(); try { n.dismiss(v.notif); } catch (e) { /* já saiu */ } }
        const notif = n.open({ type: tipo, message: ls.map(esc).join('\n') });
        const nos = document.querySelectorAll('.notyf__toast.op-toast');
        const node = nos.length ? nos[nos.length - 1] : null;
        if (node) { const x = node.querySelector('.notyf__dismiss-btn'); if (x) { x.setAttribute('type', 'button'); x.setAttribute('aria-label', t('opp27_pa_fechar')); } }
        abertos.push({ notif: notif, node: node });
    };

    // ---------- releituras ----------
    const tirarFora = () => { lista.querySelectorAll(':scope > .op-card[data-fora]').forEach((n) => n.remove()); foraId = null; };
    const marcarFora = (card, id) => {
        card.setAttribute('data-fora', '');
        card.setAttribute('aria-current', 'true');
        card.querySelectorAll('.tk-tag[data-tom="fora"]').forEach((n) => n.remove());
        const tag = document.createElement('span');
        tag.className = 'tk-tag';
        tag.dataset.tom = 'fora';
        tag.textContent = t('opp27_fora_filtro');
        const nome = card.querySelector('.op-card-nome');
        if (nome) nome.insertAdjacentElement('afterend', tag); else card.appendChild(tag);
        const depoisDosAvisos = Array.from(lista.children).find((n) => !n.classList.contains('op-aviso-fila'));
        lista.insertBefore(card, depoisDosAvisos || null);
        foraId = id;
    };
    // EP-06 da URL atual (sel da URL, LG-73). `id` = a acionada: se ela não voltou e segue aberta, o nó ANTIGO volta no topo como "fora" (R-45).
    const refrescarFila = (id, segunda) => {
        if (lista.dataset.regiao !== 'fila-card' || !fila.dataset.urlFila) { api.recontar(); return Promise.resolve(); }
        const antigo = id !== null ? lista.querySelector(':scope > #opportunity_' + id) : null;
        const copia = antigo ? antigo.cloneNode(true) : null;
        const href = api.comSelAtual(location.href);
        const u = new URL(fila.dataset.urlFila, location.href);
        u.search = new URL(href).search;
        lista.setAttribute('aria-busy', 'true');
        return api.pedir(u.toString()).then((o) => {
            lista.removeAttribute('aria-busy');
            const j = o.ok ? o.json : null;
            if (!(j && !j.error && typeof j.result.html === 'string')) { api.avisoFila(href); return; }   // E-PA5: cards antigos ficam, B-1 não muda
            const tpl = document.createElement('template');
            tpl.innerHTML = j.result.html;
            const pag = parseInt(new URL(href).searchParams.get('page') || '1', 10);
            if (!tpl.content.querySelector('.op-card') && pag > 1 && !segunda) {   // E-PA4: página que ficou vazia → a anterior (1 GET)
                const h = new URL(href); h.searchParams.set('page', String(pag - 1));
                history.replaceState(history.state, '', h.toString());
                return refrescarFila(id, true);
            }
            if (window.jQuery) window.jQuery(lista).html(j.result.html); else lista.innerHTML = j.result.html;
            api.pintarTags(lista);
            api.ligarPopovers(lista);
            const reg = document.querySelector('.op-tela .op-boxes [data-box="registros"] b');
            if (reg && Number.isInteger(j.result.totalRows)) reg.textContent = j.result.totalRows.toLocaleString('pt-BR');
            api.recontar();
            if (copia && abertaId() === id && !lista.querySelector(':scope > #opportunity_' + id)) marcarFora(copia, id);
        });
    };
    // DD-30 item 4: 1 GET EP-02 do mesmo id; trocam-se barra, faixa e contexto. A .op-conversa NUNCA é trocada (centro sem conversa: o .op-centro inteiro).
    const avisoPainel = (id) => {
        const c = det.querySelector('.op-centro');
        const f = api.clonar('op-tpl-fila-erro');
        const caixa = f ? f.firstElementChild : null;
        if (!c || !caixa) return;
        c.querySelectorAll(':scope > [data-op-pa-painel]').forEach((n) => n.remove());
        caixa.setAttribute('data-op-pa-painel', '');
        const tx = caixa.querySelector('.tk-fila-aviso-txt');
        if (tx) tx.textContent = t('opp27_pa_painel_erro');
        const b = caixa.querySelector('button');
        if (b) { b.className = 'tk-fila-aviso-acao op-pa-atualizar'; b.textContent = t('opp27_pa_atualizar'); b.dataset.id = String(id); }
        c.insertBefore(caixa, c.firstChild);
    };
    const trocarNo = (velho, novo, pai, antesDe) => {
        if (velho && novo) velho.replaceWith(novo);
        else if (velho) velho.remove();
        else if (novo && pai) pai.insertBefore(novo, antesDe || null);
    };
    const relerDetalhe = (id) => api.pedir(modelo(id)).then((o) => {
        if (abertaId() !== id) return;   // E-PA9: outra abriu no meio
        const j = o.ok ? o.json : null;
        if (!(j && !j.error && typeof j.result.html === 'string' && j.result.html.trim() !== '')) {
            const code = j && j.result ? j.result.code : null;
            if (code === 'sem_acesso' || code === 'sem_permissao') { api.estado('op-tpl-ed3', id); return; }
            if (code === 'nao_encontrada') { api.estado('op-tpl-ed4', id); return; }
            avisoPainel(id);   // E-PA5: a barra antiga fica (mesmo nó)
            return;
        }
        const N = document.createElement('div');   // raiz-elemento: `:scope >` não casa a partir de um DocumentFragment
        N.innerHTML = j.result.html;
        const nb = N.querySelector(':scope > header.op-barra[data-regiao="barra"]');
        if (!nb) { avisoPainel(id); return; }
        const corpo = det.querySelector(':scope > .op-corpo');
        const centro = corpo ? corpo.querySelector(':scope > .op-centro') : null;
        const nCentro = N.querySelector('.op-corpo > .op-centro');
        const novos = [];
        trocarNo(det.querySelector(':scope > header.op-barra[data-regiao="barra"]'), nb, det, det.firstChild);
        if (centro) {
            const cv = centro.querySelector(':scope > .op-conversa');
            if (cv) {
                const chip = centro.querySelector(':scope > .op-faixa .op-canais');
                const nf = nCentro ? nCentro.querySelector(':scope > .op-faixa') : null;
                centro.querySelectorAll(':scope > .op-faixa').forEach((f, i) => { if (i > 0) f.remove(); });
                trocarNo(centro.querySelector(':scope > .op-faixa'), nf, centro, cv);
                if (chip) {   // o chip de canal (DD-18) é do EP-08, não do EP-02: volta para a faixa nova
                    let f = centro.querySelector(':scope > .op-faixa');
                    if (!f) { f = document.createElement('div'); f.className = 'op-faixa'; f.setAttribute('data-so-canal', ''); centro.insertBefore(f, cv); }
                    let l1 = f.querySelector(':scope > .op-faixa-l1');
                    if (!l1) { l1 = document.createElement('div'); l1.className = 'op-faixa-l1'; f.insertBefore(l1, f.firstChild); }
                    l1.appendChild(chip);
                }
                centro.querySelectorAll(':scope > [data-op-pa-painel]').forEach((n) => n.remove());
            } else if (nCentro) { centro.replaceWith(nCentro); novos.push(nCentro); }
        }
        const ctx = corpo ? corpo.querySelector(':scope > aside[data-regiao="contexto"]') : null;
        const nCtx = N.querySelector('.op-corpo > aside[data-regiao="contexto"]');
        if (corpo) { trocarNo(ctx, nCtx, corpo, null); if (nCtx) novos.push(nCtx); }
        api.aplicarDetalhes(det);
        api.pintarTags(det);
        const resumo = det.querySelector(':scope > .op-barra .op-barra-nums[data-resumo-url]');
        if (resumo) api.carregarResumo(resumo);
        document.dispatchEvent(new CustomEvent('op:detalhe-parcial', { detail: { id: id, raiz: det, nos: novos } }));   // A-12: .cardLoad dos nós novos
        marcarGatilhos();
    });
    const focarBarra = () => { const b = det.querySelector(':scope > header.op-barra[tabindex]'); if (b) b.focus({ preventScroll: true }); };

    // ---------- leitura da resposta (tabela do ui-posacao) ----------
    const classificar = (info, j) => {
        const r = j && typeof j === 'object' && j.result && typeof j.result === 'object' ? j.result : null;
        if (!r) return { estado: 'incerto' };
        if (r.ok === false && RECUSA.indexOf(r.code) >= 0) return { estado: 'recusa', message: j.message };
        if (j.error !== false || r.ok !== true || r.code !== 'ok' || r.acao !== info.acao || !ACOES[r.acao]) return { estado: 'incerto' };
        if (info.acao === 'newOpportunitySave' ? r.id !== null : r.id !== info.id) return { estado: 'incerto' };
        if (ACOES[r.acao].cria && !(Number.isInteger(r.novo_id) && r.novo_id > 0)) return { estado: 'incerto' };
        return { estado: 'ok', r: r };
    };
    const ler = (resp) => {
        if (resp.status === 419 || resp.redirected) return { estado: 'sessao' };
        if (resp.status !== 200) return { estado: 'incerto' };
        return resp.text().then((txt) => ({ estado: 'json', j: json(txt) }));
    };

    const sucesso = (ctx, r, semL2) => {
        const a = ACOES[r.acao];
        const modalAberto = ctx.form.isConnected && !!ctx.form.closest('.modal.show');
        fecharModal(ctx.form);
        const p = { id: r.id, novo: r.novo_id };
        if (a.cria) {
            const tp = tipoPagina();
            if (r.novo_tipo !== null && r.novo_tipo !== undefined && r.novo_tipo !== tp && typeof r.destino === 'string' && mesmaOrigem(r.destino)) { location.assign(r.destino); return; }   // R-43
            const corrida = semL2 || !modalAberto || (r.acao !== 'newOpportunitySave' && abertaId() !== r.id);
            toast('op-ok', [t(a.t, p), corrida ? null : (a.l2 ? t(a.l2, p) : null)]);
            if (corrida) { refrescarFila(null); return; }   // E-PA9: criação não abre a nova
            const urlSel = comSel(location.href, r.novo_id);
            if (tela.dataset.estagio === 'cheia' && api.vista() !== 'cards') { location.assign(urlSel); return; }   // L1 Funil/Tabela (R-44)
            history.replaceState(history.state, '', urlSel);
            refrescarFila(null);
            api.abrir(null, modelo(r.novo_id), urlSel, String(r.novo_id), null).then(focarBarra);
            return;
        }
        const aberta = abertaId() === r.id;
        const corrida = semL2 || !modalAberto || !aberta;
        toast('op-ok', [t(a.t, p), corrida ? null : (a.l2 ? t(a.l2, p) : null)]);
        if (aberta) relerDetalhe(r.id).then(() => { if (!corrida) focarBarra(); });
        refrescarFila(r.id);
    };
    const incerto = (ctx) => {
        ctx.incerto = true;
        fecharModal(ctx.form);
        toast('op-aviso', [t('opp27_pa_incerto_t'), t('opp27_pa_incerto_txt')]);
        const alvo = ctx.info.acao === 'newOpportunitySave' ? null : ctx.info.id;
        if (alvo !== null && abertaId() === alvo) relerDetalhe(alvo);
        refrescarFila(alvo);   // nunca abre novo_id, nunca repete o POST
    };
    const soltar = (chave) => {
        emVoo.delete(chave);
        marcarGatilhos();
        const fs = formsDe.get(chave);
        if (fs) fs.forEach((f) => {
            if (!f.isConnected) { fs.delete(f); return; }
            f.querySelectorAll('[data-op-pa-alerta]').forEach((n) => { if (n.textContent === t('opp27_pa_em_voo')) n.remove(); });
            const pr = primario(f); if (pr) { pr.disabled = false; pr.removeAttribute('aria-busy'); }
        });
    };
    const enviar = (form, info) => {
        const pr = primario(form);
        if (emVoo.has(info.chave)) { emVooNoModal(form); return; }   // E-PA1: 0 POST
        form.querySelectorAll('[data-op-pa-alerta]').forEach((n) => n.remove());
        emVoo.add(info.chave);
        marcarGatilhos();
        if (pr) { pr.disabled = true; pr.setAttribute('aria-busy', 'true'); }
        const ctx = { form: form, info: info, incerto: false, relogio: false };
        const relogio = setTimeout(() => { ctx.relogio = true; incerto(ctx); }, RELOGIO_MS);   // E-PA7 aos 30 s; a trava FICA
        const csrf = window.CSRF_TOKEN || (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
        fetch(info.nova, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': csrf, 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: new URLSearchParams(new FormData(form)).toString(),
        }).then(ler).then((o) => (o.estado === 'json' ? classificar(info, o.j) : o), () => ({ estado: 'incerto' })).then((res) => {
            clearTimeout(relogio);
            soltar(info.chave);   // a chave sai SÓ aqui: o fetch assentou
            if (ctx.relogio) { if (res.estado === 'ok') sucesso(ctx, res.r, true); return; }   // E-PA9 depois do E-PA7
            if (res.estado === 'ok') { sucesso(ctx, res.r, false); return; }
            if (res.estado === 'recusa' || res.estado === 'sessao') {   // E-PA6 / E-PA8: modal ABERTO, nada relido
                const texto = res.estado === 'sessao' ? t('opp27_pa_sessao') : decodificar(res.message);
                if (form.isConnected) alertar(form, texto);
                else { const st = document.getElementById('op-status'); if (st) st.textContent = texto; }
                return;
            }
            incerto(ctx);
        });
    };
    const aoSubmeter = (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement) || !tela.isConnected) return;
        const info = preparar(form);
        if (!info) return;
        e.preventDefault();
        e.stopImmediatePropagation();   // captura da window: nenhum ouvinte do document (submitAjax, confirm-on-submit) roda
        // a validação do formulário antigo segue valendo: o jquery-validate põe `novalidate` e valida no ouvinte DELE (que não roda mais)
        const $f = window.jQuery ? window.jQuery(form) : null;
        if ($f && $f.data('validator')) { if (!$f.valid()) return; } else if (typeof form.checkValidity === 'function' && !form.checkValidity()) { if (form.reportValidity) form.reportValidity(); return; }
        enviar(form, info);
    };
    const aoClicar = (e) => {
        const b = e.target instanceof Element ? e.target.closest('.op-pa-atualizar') : null;
        if (!b || !tela.contains(b)) return;
        const id = parseInt(b.dataset.id, 10);
        const card = lista.querySelector(':scope > #opportunity_' + id + ' > .op-card-abrir');
        if (card && !card.disabled) card.click(); else api.abrir(null, modelo(id), null, String(id), null);
    };
    const aoDetalhe = (e) => {   // o card "fora" sai quando outra abre ou o detalhe fecha
        const id = e.detail ? parseInt(e.detail.id, 10) : NaN;
        if (foraId !== null && id !== foraId) tirarFora();
        marcarGatilhos();
    };

    return {
        init: function (a) {
            api = a; tela = a.tela; fila = a.fila; lista = a.lista; det = a.det;
            T = json(fila.dataset.textosPa) || {};
            new MutationObserver(observar).observe(document.body, { childList: true, subtree: true });
            window.addEventListener('submit', aoSubmeter, true);
            document.addEventListener('click', aoClicar);
            document.addEventListener('op:detalhe', aoDetalhe);
        },
    };
}();

module.exports = PosAcao;
